import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ gap }) => gap || '0.5em'};
    ${({ wrap }) => wrap ? 'flex-wrap: wrap;' : null}
    ${({ align }) => align ? 'align-items: ' + align + ';' : null}
    ${({ justify }) => justify ? 'justify-content: ' + justify + ';' : null}
`

const Row = ({ children, ...props }) => {
    return (
        <Wrapper  {...props} wrap={props.wrap ? 1 : 0}>
            {children}
        </Wrapper>
    );
}

export default Row;
